import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Carousel } from 'components/carousel/carousel';
import { ClaimCard, ClaimOutcome } from 'core/enums/rewards';
import { Paginator } from 'core/models/paging';
import { RewardCard } from 'core/models/rewards/rewards';
import RewardDetailsCard from 'rewards/common/reward-details-card/reward-details-card';
import { RewardsStore } from 'rewards/rewards.store';
import { _noop } from 'utils/function.utils';
import { PopupStore } from '../popup.store';
import styles from '../popup.module.scss';

export const PremiumExperiencePopUp = observer<{
  popupStore: PopupStore;
  rewardsStore: RewardsStore;
  rewardCards: RewardCard[] | undefined;
  onClaim: (() => void) | undefined;
}>(({ popupStore, rewardCards, rewardsStore, onClaim }) => {
  const { t } = useTranslation();

  const handleClaim = (reward: RewardCard) => {
    rewardsStore.changeItemDetails(reward);
    onClaim ? onClaim() : null;
  };

  if (!rewardCards || rewardCards.length === 0) {
    return;
  }

  if (rewardsStore.claimOutcome !== ClaimOutcome.None) {
    return (
      <RewardDetailsCard
        isLoading={rewardsStore.isLoadingClaim}
        type={ClaimCard.Reward}
        reward={rewardsStore.itemDetails}
        onClose={() => popupStore.toggleIsOpen()}
        outcome={rewardsStore.claimOutcome}
        errorMsg={rewardsStore.errorMsg}
      />
    );
  }

  const items = rewardCards?.map((_reward) => {
    const isCompetition = _reward.type?.toLocaleLowerCase() === ClaimCard.Competition.toLowerCase();
    const typeToUse = isCompetition ? ClaimCard.Competition : ClaimCard.PremiumExperience;

    return (
      <RewardDetailsCard
        isLoading={rewardsStore.isLoadingClaim}
        type={typeToUse}
        reward={_reward}
        onClose={() => popupStore.toggleIsOpen()}
        onClaim={() => handleClaim(_reward)}
        errorMsg={rewardsStore.errorMsg}
        selectOptions={rewardsStore.compEntries}
        selectVal={rewardsStore.noOfEntries}
        onSelect={(val) => rewardsStore.changeNoOfEntries(val)}
      />
    );
  });

  return (
    <div
      className={`${styles.premiumExperienceContainer} d-flex flex-column justify-content-center align-items-center`}
    >
      <Carousel
        columnCount={1}
        hasPagination
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        navigationArrows
        customNavArrowClass={styles.customArrows}
        items={new Paginator(items, 1)}
      />
    </div>
  );
});